import { render, staticRenderFns } from "./Gdpr.vue?vue&type=template&id=6d5e67b5"
import script from "./Gdpr.vue?vue&type=script&lang=js"
export * from "./Gdpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports